import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import DateRangeComponent from "../DateRangeComponent";
import {
  fetchPCClassificationsLogic,
  fetchPCMediaLogic,
  fetchPatientPCLogic,
  clearPinnedContent,
} from "../../../../../store/features/patient/pinnedContentSlice";
import { ReactComponent as PinIcon } from "../../../../../assets/icons/pin.svg";
import PinnedContentTable from "./PinnedContentTable.js";
import PatientLoader from "../../../../common/PatientLoader";
import axiosInstance, { CMS_BASE_URL } from "../../../../../axios";
import { TYPE_TO_CMS_SLUG } from "../../../../../util/helpers";
import PinnedPieChart from "./PinnedPieChart";
import PinnedBarChart from "./PinnedBarChart";
import PinNewContent from "./PinNewContent";
import PinNewContentV2 from "./PinNewContentV2.js";
const PinnedContent = (props) => {
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const [formattedData, setFormattedData] = useState([]);
  const [data, setData] = useState([]);
  const { loading, singlePatientData } = useSelector((state) => state.patient);
  const { patientPinnedContent, pinnedContentLoading } = useSelector(
    (state) => state.pinnedContent
  );
  useEffect(() => {
    if (!loading && singlePatientData?.id) {
      dispatch(clearPinnedContent()); // Clear the state first
      dispatch(fetchPatientPCLogic(singlePatientData?.id));
    }
  }, [loading, singlePatientData?.id, dispatch]);

  const curatePinnedContent = async (category, ids) => {
    const res = await axiosInstance.get(`${CMS_BASE_URL}/content-type/${category}/`, {
      headers: { Authorization: `JWT ${localStorage.access}` },
      params: { id_in: ids },
    });
    const items = (res?.data || []).map((item) => {
      if (!item.media_type) {
        item.media_type = category;
      }
      return item;
    });
    return { [category]: items };
  };
  useEffect(() => {
    if (patientPinnedContent && patientPinnedContent.length > 0) {
    handlePinnedContentFormatting();
    }
    // return ()=>dispatch(clearPinnedContent());
  }, [patientPinnedContent]);

  useEffect(() => {
    return ()=>dispatch(clearPinnedContent());
  },[ ]);

  const handlePinnedContentFormatting = async () => {
    console.log("handlePinnedContentFormatting started. patientPinnedContent:", patientPinnedContent);
    console.log("TYPE_TO_CMS_SLUG check:", typeof TYPE_TO_CMS_SLUG, TYPE_TO_CMS_SLUG);
    const hashmap = {};
    const timestamps = {};

    try {
      patientPinnedContent?.forEach((element, idx) => {
        console.log(`Processing element [${idx}]:`, element);
        const type = element?.type;
        let category;
        if (TYPE_TO_CMS_SLUG) {
          category = TYPE_TO_CMS_SLUG[type] || type;
        } else {
          console.error("TYPE_TO_CMS_SLUG is undefined!");
          category = type;
        }
        console.log(`Resolved category for element [${idx}]:`, category);
        if (!category || category === "undefined" || category === "null") {
          console.warn(`Skipping unknown pinned content type: ${type}`);
          return;
        }
        timestamps[element?.identifier] = element?.modified;
        if (category in hashmap) {
          hashmap[category].push(element.identifier);
        } else {
          hashmap[category] = [element.identifier];
        }
      });
    } catch (forEachError) {
      console.error("Error in patientPinnedContent forEach loop:", forEachError);
    }

    console.log("hashmap created:", hashmap);

    const final = [];
    let unformatted = [];
    for (const [key, value] of Object.entries(hashmap)) {
      if (!key || key === "undefined" || key === "null") {
        continue;
      }
      try {
        console.log(`Curating content for key: ${key}, value:`, value);
        let temp = await curatePinnedContent(key, value);
        console.log(`Curation result for key ${key}:`, temp);
        if (temp && temp[key]) {
          unformatted = unformatted.concat([...temp[key]]);
          final.push(temp);
        }
      } catch (error) {
        console.error(`Error curating pinned content for category ${key}:`, error);
      }
    }

    console.log("unformatted before mapping/sorting:", unformatted);

    try {
      unformatted = unformatted
        .filter(Boolean)
        .map((item) => {
          if (item) {
            item["pinned_at"] = timestamps[item?.id] || new Date().toISOString();
          }
          return item;
        })
        .sort((a, b) => {
          const dateA = new Date(a?.pinned_at || 0);
          const dateB = new Date(b?.pinned_at || 0);
          return dateA - dateB;
        });
    } catch (mappingError) {
      console.error("Error mapping/sorting unformatted pinned content:", mappingError);
    }

    console.log("formatted unformatted data:", unformatted);

    if( patientPinnedContent.length > 0){
      console.log("setting data:", unformatted, "formatted:", final);
      setFormattedData(final);
      setData(unformatted);
    }
    else {
      setFormattedData([]);
      setData([]);
    }
   
  };



  return (
    <div className="container-fluid" style={{ margin: "0px", padding: "0px" }}>
      {/* <DateRangeComponent /> */}
      <div className="row px-3">
        <PinnedPieChart
          title="By Category"
          patientPinnedContent={data}
          pinnedContentLoading={pinnedContentLoading}
        />
        <PinnedBarChart
          title="By Content Format"
          patientPinnedContent={patientPinnedContent}
          pinnedContentLoading={pinnedContentLoading}
        />
      </div>

      <CardLayout
        className="col-sm-12 col-md-12 col-lg-12"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <div className="container-fluid px-4 pb-4">
          <PinNewContentV2 patientID={props?.id} />
        </div>
      </CardLayout>
      <CardLayout
        className="col-sm-12 col-md-12 col-lg-12"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <PinNewContent
          modalIsOpen={isModalOpen}
          setModalOpen={setModalOpen}
          patientID={props?.id}
        />
        <div className="container-fluid d-flex mt-2 justify-content-between">
          <label style={{ fontSize: "1.3rem" }}>All Pinned Content</label>
          {/* /**hidden this button for now.*/ }
          {/* <button
            className="primary-btn"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <PinIcon /> Pin New Content
          </button> */}
        </div>

        <div className="container-fluid px-4 pb-4">
          {pinnedContentLoading ? (
            <PatientLoader />
          ) : (
            <PinnedContentTable data={data} setFormattedData={setFormattedData} setData={setData}/>
          )}
        </div>
      </CardLayout>
    </div>
  );
};
export default PinnedContent;
